import React from 'react';
import { ShieldIcon, EyeIcon } from 'lucide-react';
export function About() {
  return <section className="py-16 border-b border-gray-800" data-id="element-22">
      <div className="max-w-4xl mx-auto" data-id="element-23">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 md:mb-8 flex items-center gap-3" data-id="element-24">
          <ShieldIcon className="w-7 h-7 md:w-8 md:h-8 text-orange-500" data-id="element-25" />
          Over mij
        </h2>
        <div className="grid md:grid-cols-5 gap-6 md:gap-8" data-id="element-26">
          <div className="md:col-span-3" data-id="element-27">
            <p className="text-base md:text-lg text-gray-300 leading-relaxed mb-4 md:mb-6" data-id="element-28">
              Sinds 2022 werk ik volledig als professioneel beveiliger, waarbij
              ik mijn Diploma Beveiliger, SVPB verklaring en certificaat als BHV
              Ploegleider inzet om hoogwaardige beveiligingsdiensten te leveren.
              Mijn focus ligt op het bieden van betrouwbare en effectieve
              beveiliging voor diverse situaties.
            </p>
            <p className="text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-29">
              Voorafgaand aan mijn carrière in beveiliging heb ik ruime ervaring
              opgedaan in de retail sector (2015-2022), wat mij waardevolle
              vaardigheden heeft bijgebracht in observatie, klantenservice en
              het oplossen van conflictsituaties. Deze achtergrond versterkt
              mijn effectiviteit als beveiliger, vooral in commerciële
              omgevingen.
            </p>
          </div>
          <div className="md:col-span-2 bg-gray-800 p-5 md:p-6 rounded-lg border-l-4 border-orange-500 shadow-lg" data-id="element-30">
            <blockquote className="text-lg md:text-xl italic text-gray-200" data-id="element-31">
              "Veiligheid door professionaliteit, observatie en preventie, dat
              is waar ik voor sta."
            </blockquote>
            <div className="mt-4 text-right text-orange-500 font-semibold" data-id="element-32">
              — Emre Tarik Aksoy
            </div>
          </div>
        </div>
      </div>
    </section>;
}